/**
 * DataChip Colors — data-driven display colors, not themed.
 */

export const dataChipColors = {
  dataType: {
    rankings: { color: "#366104", bg: "#ECF8D9" },
    bilateral: { color: "#891D49", bg: "#FFE5EC" },
    unilateral: { color: "#095582", bg: "#EBF9FE" },
    product: { color: "#6212A5", bg: "#F2E8FF" },
    classification: { color: "#796138", bg: "#F2EEC2" },
    productSpace: { color: "#387879", bg: "#C2F2EF" },
    productRepo: { color: "#796138", bg: "#F2E8C2" },
    default: { color: "#666666", bg: "#F5F5F5" },
  },
  classification: {
    HS92: { color: "#F1C59F", bg: "#FFF3E0", stroke: "#F1C59F" },
    HS12: { color: "#F1A29F", bg: "#FFEBEE", stroke: "#F1A29F" },
    HS22: { color: "#F08B6C", bg: "#FFE9E1", stroke: "#F08B6C" },
    SITC: { color: "#7DDDE4", bg: "#E0F7FA", stroke: "#7DDDE4" },
    Services: { color: "#8FD096", bg: "#E8F5E9", stroke: "#8FD096" },
    default: { color: "#666666", bg: "#F5F5F5" },
  },
  outlinedBorder: "#A7A7A7",
} as const;

/** Data visualization palette for methodology classification figures */
export const dataVizClassification = {
  hs2007: "#E80D0D",
  hs2002: "#E86710",
  hs1996: "#EDBB12",
  hs1992: "#33D64A",
} as const;

export const dataVizClassificationPalette = [
  dataVizClassification.hs2007,
  dataVizClassification.hs2002,
  dataVizClassification.hs1996,
  dataVizClassification.hs1992,
] as const;
